// Pas starten als de hele pagina (en dus het bundelblok) geladen is
function initStickyAtc() {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const form = bar.querySelector('.sticky-atc__form');
  const stickyVariantInput = bar.querySelector('[data-sticky-atc-variant]');
  const priceEl = bar.querySelector('[data-sticky-atc-price]');
  const compareEl = bar.querySelector('[data-sticky-atc-compare]');
  const subtitleEl = bar.querySelector('[data-sticky-atc-subtitle]');
  const btn = bar.querySelector('.sticky-atc__btn');

  const variantsEl = document.querySelector('[data-sticky-atc-variants]');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const money = cents => '€' + (cents / 100).toFixed(2).replace('.', ',');

  function applyVariant(variantId){
    const v = variants.find(x => String(x.id) === String(variantId));
    if (!v) return;
    stickyVariantInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
    if (subtitleEl && v.public_title) subtitleEl.textContent = v.public_title;
    if (btn) v.available ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', 'disabled');
  }

  // --- 1) Volg de gekozen variant (variantkiezer of bundelblok) ---
  function findMainVariantField(){
    return Array.from(document.querySelectorAll('select[name="id"], input[name="id"]'))
      .find(el => !bar.contains(el)) || null;
  }
  const mainField = findMainVariantField();
  if (mainField){
    applyVariant(mainField.value);
    // Het bundelblok zet de waarde via JS; daarom na elke wijziging op de pagina opnieuw uitlezen
    document.addEventListener('change', e => {
      if (bar.contains(e.target)) return;
      requestAnimationFrame(() => applyVariant(mainField.value));
    });
    document.addEventListener('variant:change', e => {
      if (e?.detail?.variant?.id) applyVariant(e.detail.variant.id);
    });
  }

  // --- 2) Klik = de echte koopknop gebruiken, zodat bundel, routine en cart drawer meegaan ---
  // Eerst de knop van het bundelblok; alleen als die er niet is een andere koopknop
  function findMainATCButton(){
    const bundleBtn = document.querySelector('.bs .bs-btn');
    if (bundleBtn) return bundleBtn;
    return Array.from(document.querySelectorAll(
      'button[name="add"].atc-button, button[type="submit"][name="add"]'
    )).find(el => !bar.contains(el) && !el.closest('cart-drawer')) || null;
  }
  const mainATC = findMainATCButton();

  form.addEventListener('submit', e => {
    if (!mainATC || mainATC.disabled) return; // valt terug op het eigen formulier
    e.preventDefault();
    mainATC.click();
  });

  // --- 3) Tonen pas voorbij de normale koopknop, verbergen bij de footer ---
  // Alleen tonen als de koopknop BOVEN het scherm ligt (je bent er naar beneden voorbij).
  // Ligt hij onder het scherm (je bent erboven, bij de foto's), dan blijft de balk weg.
  let atcAbove = false, footerInView = false, drawerOpen = false;

  // Positie van een element zonder zijn huidige verschuiving (transform), ook halverwege een animatie
  function naturalRect(el){
    const r = el.getBoundingClientRect();
    const t = getComputedStyle(el).transform;
    const m = t && t !== 'none' ? new DOMMatrixReadOnly(t) : { m41: 0, m42: 0 };
    return { top: r.top - m.m42, bottom: r.bottom - m.m42, left: r.left - m.m41 };
  }

  // WebwinkelKeur-blokje precies boven de balk zetten, met een kleine tussenruimte (zie CSS)
  function placeWwk(){
    const wwk = document.querySelector('.wwk-sidebar--mobile--bottom');
    if (!wwk) return;
    const gap = -1; // ≈ 8px zichtbare ruimte (WebwinkelKeur heeft binnenin nog ~9px extra)
    const inner = bar.querySelector('.sticky-atc__inner');
    const b = naturalRect(bar);           // balk op zijn zichtbare plek
    const innerLeft = inner.getBoundingClientRect().left;
    // Alleen het zichtbare roze deel meten (logo + score), niet de onzichtbare ruimte eromheen
    const t = getComputedStyle(wwk).transform;
    const m = t && t !== 'none' ? new DOMMatrixReadOnly(t) : { m41: 0, m42: 0 };
    const parts = [...wwk.children].map(c => c.getBoundingClientRect()).filter(r => r.width > 0 && r.height > 0);
    const w = parts.length
      ? { bottom: Math.max(...parts.map(r => r.bottom)) - m.m42, left: Math.min(...parts.map(r => r.left)) - m.m41 }
      : naturalRect(wwk);                 // blokje op zijn gewone plek
    const html = document.documentElement;
    html.style.setProperty('--satc-lift', Math.max(0, w.bottom - b.top + gap) + 'px');
    html.style.setProperty('--satc-shift-x', (innerLeft - w.left) + 'px');
  }

  function updateSticky(){
    const visible = atcAbove && !footerInView && !drawerOpen;
    bar.classList.toggle('is-visible', visible);
    document.documentElement.classList.toggle('satc-visible', visible);
    if (visible) placeWwk();
  }

  // Winkelwagen-lade open? Dan de balk verbergen (de lade krijgt dan de class "active")
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const checkDrawer = () => {
      drawerOpen = cartDrawer.classList.contains('active');
      updateSticky();
    };
    new MutationObserver(checkDrawer).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Adresbalk in/uit of draaien van het scherm: opnieuw meten
  window.addEventListener('resize', () => { if (bar.classList.contains('is-visible')) placeWwk(); });



  if (mainATC && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const entry = entries[0];
      atcAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      updateSticky();
    }, { threshold: 0.01 }).observe(mainATC);
  }

  function initFooterObserver(){
    const footerEl = document.querySelector('.rm-footer');
    if (!footerEl || !('IntersectionObserver' in window)) return false;
    new IntersectionObserver(entries => {
      footerInView = entries[0].isIntersecting;
      updateSticky();
    }, { threshold: 0.01 }).observe(footerEl);
    return true;
  }
  if (!initFooterObserver()){
    window.addEventListener('load', () => {
      if (initFooterObserver()) return;
      let tries = 0;
      const t = setInterval(() => {
        tries++;
        if (initFooterObserver() || tries > 40) clearInterval(t);
      }, 100);
    });
  }

  function syncInitialState(){
    if (mainATC) {
      const r = mainATC.getBoundingClientRect();
      atcAbove = r.bottom < 0;
    }
    const f = document.querySelector('.rm-footer');
    if (f) {
      const fr = f.getBoundingClientRect();
      footerInView = fr.top < window.innerHeight && fr.bottom > 0;
    }
    updateSticky();
  }
  syncInitialState();
  requestAnimationFrame(syncInitialState);
  window.addEventListener('load', syncInitialState);
  window.addEventListener('pageshow', syncInitialState);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyAtc);
else initStickyAtc();
